import uuid from 'uuid/v1';

export default [
  {
    id: uuid(),
    Company: 'باربری ایساتیس',
  },
  {
    id: uuid(),
    Company: 'باربری کویر',
  },
  {
    id: uuid(),
    Company: 'باربری اتوبار',
  },
  {
    id: uuid(),
    Company: 'باربری امیر',
  },
  
  
];
